<script lang="ts">
	// import { initHeroHomeSwiper } from '$lib/js/script';
	// import 'bootstrap/dist/css/bootstrap.min.css'; 
    import { _ } from 'svelte-i18n';
	import { onMount } from 'svelte';   

    export let promo;

	onMount(async () => {
		// import('bootstrap');
		// initHeroHomeSwiper();

        // Impor Bootstrap secara dinamis
        const { Modal } = await import('bootstrap');
        // Ambil elemen modal berdasarkan ID
        const modalElement = document.getElementById('BannerPopUp') as HTMLDivElement | null;
        if (modalElement) {
        // Inisialisasi modal Bootstrap
        const bootstrapModal = new Modal(modalElement);
        // Tampilkan modal

        setTimeout(() => {
          bootstrapModal.show();
        }, 6000);
        
    }
        
	});
</script>

<!-- Modal -->
{#if promo?.length>0}
    <div class="modal fade" id="BannerPopUp" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content" style="border: none; margin:auto; background-color:transparent !important;">
                <div class="modal-body p-0">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper mySwiperPopup">
                        <div class="swiper-wrapper">
                            {#each promo as item }
                            <div class="swiper-slide">
                                <div class="d-flex flex-column align-items-center gap-3 justify-content-center">
                                    <a data-sveltekit-reload href="{item?.link}" target="_blank" class="d-none d-md-block">
                                        <img src="{item?.featured_images[0]?.path}" class="img-fluid w-100" alt="{item?.description}">
                                    </a>
                                    <a data-sveltekit-reload href="{item?.link}" target="_blank" class="d-block d-md-none">
                                        <img src="{item?.featured_imagesmob[0]?.path}" class="img-fluid w-100" alt="{item?.description}">
                                    </a>
                                    <a data-sveltekit-reload href="{item?.link}" class="font-navdesktop ff-lola-bir d-flex justify-content-center btn btn-light" style="max-width:max-content; border-radius:0px;">{$_('btn_book')}</a>
                                </div>
                            </div>
                            {/each}
                        </div>
                    </div>
                <div class="swiper-button-next"></div>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>
    #BannerPopUp .btn-close{
        color: #000;
        text-decoration: none;
        opacity: 1;
        position: absolute;
        right: 1%;
        top: 1%;
        background-color: rgba(255,255,255, 0.5);
        border-radius: 100%;
        padding:5px;
        z-index: 5;
    }
    #BannerPopup .modal-content{
      background: none;
    }
    #BannerPopUp .swiper-button-next,
    #BannerPopUp .swiper-button-prev{
      color: #fff !important;
    }
    #BannerPopUp .swiper-button-next{
        right: 10px;
    }
        #BannerPopUp .swiper-button-prev{
        left: 10px;
    }

    @media (min-width: 768px) {
        #BannerPopUp .swiper-button-next{
            right: -40px;
        }

        #BannerPopUp .swiper-button-prev{
            left: -40px;
        }
    }

    /* @media (min-width: 992px) { */
    /* .modal-lg {
        --bs-modal-width: 670px;
    } */
    /* } */

    .font-navdesktop{
		font-size: 16px;
	}

	@media (min-width: 1512px) {
		.font-navdesktop {
			font-size: 1.25rem;
		}
	}

	@media (min-width: 1728px) {
		.font-navdesktop {
			font-size: 1.25rem;
		}

	}
</style>